module.exports = __webpack_public_path__ + "img/img58.a6de1f92.png";